const {
	prepareFacets,
} = require('public/js/components/search-facets');

const {
	prepareFilters,
} = require('public/js/components/search-filters');

const {
	prepareSearchResults,
	category,
} = require('public/js/search-helper');
const { prepareCatalog } = require('../../../js/catalog-helper');
const utils = require('public/js/helpers/utils');
const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');

/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/

	(function SearchListingModule() {
		$onReady({
			rp$, window,
			label: 'search_listing',
			fn: function () {
				function numberWithCommas(x) {
					return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}

				function resultCountTween($el, start, end, decrement) {
					let step = 9;
					let diff = Math.abs(start - end);

					if (start === end) {
						$el.text(numberWithCommas(end));
						return; // Do nothing
					}

					if (decrement === true && start <= end) {
						$el.text(numberWithCommas(end));
						return;
					} else if (decrement === false && start >= end) {
						$el.text(numberWithCommas(end));
						return;
					}

					if (diff > 100) {
						step = Math.round((diff / 100) * 9);
					}

					start = (decrement === true) ? start - step : start + step;

					$el.text(numberWithCommas(start));

					if (start !== end) {
						setTimeout(function () {
							resultCountTween($el, start, end, decrement);
						}, 1);
					}
				}

				function handleNewCount($countEle, newCount) {
					var start = parseInt($countEle.text().toString().replace(/[^\d]/g,''), 10) || 0;
					var end = parseInt(newCount.toString().replace(/[^\d]/g,''), 10) || 0;
					var decrement = (start > end) ? true : false;
					resultCountTween($countEle, start, end, decrement);
				}

				rp$('.search-listing-module').parent().on('click', '.catalog-info-show-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					var fullInfo = rp$(this).data('full-info');
					rp$(this).parent().html(fullInfo);
				});
				if(window.tracking.google.use_gtag_admind_analytics){
					rp$('.product-title').on('click', 'a', function HookProductTitleClick(evt) {
						const product = utils.productTitleEvent( rp$(this).parent().parent() , rp$('.subcategory.active-cat')[0], 'Search');
						window.rp_app.track.track_ec_general('select_item', {
							currency:window.rp_app.cart._currency_code,
							items:utils.convertNamesOfItemsForGA([product])
						});
					});
				}

				rp$('.search-listing-module').parent().on('click', '.fitment-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					const elementsWithHideClass = rp$(this).parent().find('.hide');
					const elementsWithShowClass = rp$(this).parent().find('.show');
					elementsWithHideClass.addClass('show');
					elementsWithHideClass.removeClass('hide');
					elementsWithShowClass.addClass('hide');
					elementsWithShowClass.removeClass('show');
					rp$(this).addClass('hide');
				});

				rp$('.search-listing-module').parent().on('click', '.pagination-link', function HookPaginationClick(evt) {
					evt.preventDefault();

					var page = rp$(this).data('page');
					rp$(document).trigger('searchResults:pageChange', page);

					// Scroll to top of results
					rp$('html, body').animate({ scrollTop: 0 }, 'slow');
				});

				/* Handle Search Results Request
				.*-----------------------------------------*/
				function HandleSearchResultsRequest(evt) {
					partTypeFilterHelpers.showSpinner();
				}
				rp$(document).off('searchResults:request', HandleSearchResultsRequest);
				rp$(document).on('searchResults:request', HandleSearchResultsRequest);

				/* Handle Search Results Error
				.*-----------------------------------------*/
				function HandleSearchResultsError(evt) {
					rp$('.search-listing-module').overlaySpinner.remove();
					rp_app.notify.add_notification(javascriptContent.search_error, 'error');
				}
				rp$(document).off('searchResults:error', HandleSearchResultsError);
				rp$(document).on('searchResults:error', HandleSearchResultsError);

				/* Handle Search Results Response
				.*-----------------------------------------*/
				function HandleSearchResultsResponse(evt, response) {
					var $listingModule = rp$('.search-listing-module');
					$listingModule.overlaySpinner.remove();
					const displayTitlesInSearchListings = response.display_titles_in_search_listings;
					const originalResultCount = rp$('.search-listing-page-titles .result-count').text().replace(/[^\d]/g,'') ?? 0;

					if(response.listings_html) {
						$listingModule.replaceWith(response.listings_html);
						
						if (!displayTitlesInSearchListings) {
							var $newListingModule = rp$('.search-listing-module');
							var $pageSubheaderTitles = $newListingModule.find('.search-listing-page-titles');
							
							var useNewSearchUi = $newListingModule.hasClass('search-based-v-page');
							if (!useNewSearchUi) {
								var useNewSearchUiData = rp$('.vehicle-filters-module-container').data('use-new-search-ui');
								useNewSearchUi = (useNewSearchUiData === true || useNewSearchUiData === 'true' || useNewSearchUiData === 1 || useNewSearchUiData === '1');
							}
							
							if ($pageSubheaderTitles.length === 0 && response.page_subheader_title_data && useNewSearchUi) {
								var titleHtml = '<div class="search-listing-page-titles">';
								if (response.page_subheader_title_data.show_title) {
									var headingTag = response.page_subheader_title_data.is_not_main_heading ? 'h2' : 'h1';
									titleHtml += '<' + headingTag + ' data-test-id="search-listing__page_heading">' + response.page_subheader_title_data.page_heading + '</' + headingTag + '>';
									if (response.page_subheader_title_data.page_subheading) {
										titleHtml += '<h3 data-test-id="search-listing__page_subheading">' + response.page_subheader_title_data.page_subheading + '</h3>';
									}
								}
								titleHtml += '</div>';
								$newListingModule.prepend(titleHtml);
							}
						}
						
						if (typeof rp$.fn.add_to_cart === 'function') {
							rp$('.search-listing-module').find('.add-to-cart.enabled').add_to_cart();
						}
						if (typeof rp$.fn.product_quantity === 'function') {
							rp$('.search-listing-module').product_quantity();
						}
					}

					var $addMobile = rp$('.filters-overlay-content').find('.search-facets-module');
					var $addDesktop = rp$('.desktop-search-filters').find('.search-facets-module');

					if(response.mobile_facets) {
						$addMobile.replaceWith(response.mobile_facets);
					} else {
						$addMobile.find('.multi-select-facet-checkbox').prop("disabled", false);
					}

					if(response.desktop_facets) {
						$addDesktop.replaceWith(response.desktop_facets);
					} else {
						$addDesktop.find('.multi-select-facet-checkbox').prop("disabled", false);
					}

					if (response.use_cfc) {
						prepareCatalog();
					} else {
						prepareSearchResults(response.use_cfc);
					}
					prepareFacets();

					if(response.mobile_filters || response.desktop_filters) {
						var $addFiltersMobile = rp$('.filters-overlay-content').find('.vehicle-filters-module-container');
						var $addFiltersDesktop = rp$('.desktop-search-filters').find('.vehicle-filters-module-container');
						$addFiltersDesktop.replaceWith(response.desktop_filters);
						$addFiltersMobile.replaceWith(response.mobile_filters);
						prepareSearchResults();
						prepareFilters();
					}

					if (displayTitlesInSearchListings) { 
						rp$('.result-count').each(function CountEle_Iterator(/*idx*/) {
							rp$(this).text(originalResultCount);
							handleNewCount(rp$(this), response.count);
						});
						rp$('.result-ymm-text').html(response.ymm_text);
						rp$('.result-text').html(response.query);
						rp$('.search-bar-component input[type=text]').val(response.query);
					} else {
						var $dynamicHeaderResultCount = rp$('.dynamic-header-content-titles .result-count');
						if ($dynamicHeaderResultCount.length > 0) {
							var originalCount = parseInt($dynamicHeaderResultCount.text().replace(/[^\d]/g,''), 10) || 0;
							$dynamicHeaderResultCount.text(originalCount);
							handleNewCount($dynamicHeaderResultCount, response.count);
						}
						
						var $dynamicHeaderYmmText = rp$('.dynamic-header-content-titles .result-ymm-text');
						if ($dynamicHeaderYmmText.length > 0 && response.ymm_text) {
							$dynamicHeaderYmmText.html(response.ymm_text);
						}
						var $dynamicHeaderResultText = rp$('.dynamic-header-content-titles .result-text');
						if ($dynamicHeaderResultText.length > 0 && response.query) {
							$dynamicHeaderResultText.html(response.query);
						}
					}
				}
				rp$(document).off('searchResults:response', HandleSearchResultsResponse);
				rp$(document).on('searchResults:response', HandleSearchResultsResponse);

				rp$(document)
					.off('click', '.catalog-product-card-fitment-add-vechicle')
					.on('click', '.catalog-product-card-fitment-add-vechicle', () => window.openVehiclePicker({redirect: 'reload'}));
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
